import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const CollapseIconBordered = (props: IconProps) => {
  const { color = FORTA_BLUE.primary, width = 24, height = 24 } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
      style={{ display: 'block' }}
      aria-hidden="true"
    >
      <rect x="1.5" y="1.5" width="41" height="41" rx="7.5" stroke={color} />
      <path
        d="M13 14L22 22L31 14"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 22L22 30L31 22"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CollapseIconBordered;
